import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense.ts";
import useScannerMode from "@/hooks/use-scanner-mode.ts";
import useTranslation from "@babackapp/translations/use-translation";
import { Label } from "@babackapp/ui/components/label";
import { SidebarMenuButton } from "@babackapp/ui/components/sidebar";
import { Switch } from "@babackapp/ui/components/switch";
import { ScanBarcodeIcon } from "lucide-react";
import { useState } from "react";

export default function ScannerButton() {
  const { data: shop } = useCurrentShopSuspense();
  const [active, setActive] = useState(false);
  const t = useTranslation();

  useScannerMode({ shopId: shop.id, active });

  return (
    <SidebarMenuButton className="inline-flex">
      <ScanBarcodeIcon className="h-4 w-4" />
      <Label htmlFor="scanner-mode" className="flex-1">
        {t("scannerMode.title")}
      </Label>
      <Switch
        id="scanner-mode"
        className="data-[state=unchecked]:bg-gray-600"
        checked={active}
        onCheckedChange={setActive}
      />
    </SidebarMenuButton>
  );
}
